<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="icon-close" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.928955" y="13.6569" width="18" height="2" rx="1" transform="rotate(-45 0.928955 13.6569)"/>
    <rect x="2.34314" y="0.928955" width="18" height="2" rx="1" transform="rotate(45 2.34314 0.928955)"/>
  </svg>

</template>

<script setup lang="ts">

</script>

<style lang="scss" >
.icon-close {
  display: inline-block;
  fill: white;
}
</style>